import type { InputProps } from "react-aria-components";

import React from "react";
import { Group } from "react-aria-components";

import { composeTailwindRenderProps } from "@/components/utils";

import { Input } from ".";
import { ClearButton } from "./ClearButton";

interface ClearableInputProps extends InputProps {
  onClear: () => void;
  showClearButton?: boolean;
}

export const ClearableInput = React.forwardRef<
  HTMLInputElement,
  ClearableInputProps
>(function ClearableInput(
  { onClear, showClearButton = true, ...inputProps },
  ref,
) {
  return (
    <Group
      className="isolate grid grid-cols-[1fr_calc(theme(size.6)+16px)]"
      data-ui="control"
    >
      <Input
        {...inputProps}
        className={composeTailwindRenderProps(inputProps.className, [
          "col-span-full",
          "row-start-1",
          showClearButton ? "pr-10" : "",
        ])}
        ref={ref}
      />
      {showClearButton && (
        <ClearButton
          className="z-10 -col-end-1 row-start-1 place-self-center"
          onPress={onClear}
        />
      )}
    </Group>
  );
});
